import { api } from "@/api"
import type { ClientCurrencyCode } from "../sharedTypes/tenants"

type RetrieveSelfMerchantGroupMerchant = {
  name: string
  hasDonationsModule: boolean
  hasSalesModule: boolean
  schemaName: string
}

type RetrieveSelfMerchantGroupResponse = {
  id: string
  name: string
  merchants: Array<RetrieveSelfMerchantGroupMerchant>
  currency: ClientCurrencyCode
}

export const retrieveSelfMerchantGroup = async () => {
  const { body } =
    await api.get<RetrieveSelfMerchantGroupResponse>(
      "/merchant-group/self/",
      {
        isMerchantGroup: true,
      }
    )
  return body
}
